<template>
  <el-form :model="ruleForm" ref="ruleForm" label-width="0px" class="multiple">
    <el-form-item v-for="(item, index) in ruleForm.inputs" :key="index">
      <el-input style="width:60%;margin-right: 5px;" v-model="item.value"></el-input>
      <el-button @click.prevent="remove(item, index)">删除</el-button>
      <el-button v-if="ruleForm.inputs.length > 1 && index != 0" @click.prevent="move(item, index)">上移</el-button>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="add()">添加</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    initData: ''
  },
  data() {
    return {
      ruleForm: {
        inputs: [

        ]
      }
     };
  },
  methods: {
    remove(item, index) {
      this.ruleForm.inputs.splice(index, 1)
    },
    move(item, index) {
      this.ruleForm.inputs[index] = this.ruleForm.inputs.splice(index - 1, 1, this.ruleForm.inputs[index])[0]
    },
    add() {
      this.ruleForm.inputs.push({value: ''})
    },
    childEmit() {
      let values = []
      let inputLen = this.ruleForm.inputs.length
      if(inputLen && this.ruleForm.inputs[0].value) {
        this.ruleForm.inputs.forEach(item => {
          item.value && values.push(item.value)
        })
        return values.join(';')
      }else {
        return ''
      }
    }
   },
  components: {

  },
  computed: {

  },
  watch: {
    initData: {
      handler(v) {
        if(v) {
          this.ruleForm = {
            inputs: []
          }
          if(typeof(v) == 'string') {
            let arr = v.split(';')
            arr.forEach(item => {
              if(item) {
                this.ruleForm.inputs.push({value: item})
              }

            })
          }
        }
      },
      immediate: true
    }
  },
  mounted() {

  },
  created() {

  }
}
</script>

<style lang="scss">
  .multiple{
     .el-form-item{
      width: 100% !important;
    }
  }
</style>
